import { useParams } from 'react-router-dom'
import { FacebookCampaignsInsights, useStatsSingleProject } from '../../../hooks/useStatsSingleProject'
import { Table } from 'antd'
import { toUS } from '../utils'

export function FacebookCampaignsTable() {
  const { projectId } = useParams() as { projectId: string }
  const { facebookCampaignsInsights } = useStatsSingleProject(projectId)

  const TitleWithDesc = ({ title, desc }: { title: string; desc: string }) => (
    <div>
      <p style={{ lineHeight: '14px' }}>
        {title}
        <br />
        <span className="text-muted" style={{ fontSize: '0.6rem' }}>
          {desc}
        </span>
      </p>
    </div>
  )

  const columns = [
    {
      title: 'Facebook Campaign',
      dataIndex: 'campaign_name',
      key: 'name',
    },
    /*  { // TODO: maybe add linked sites.
      title: 'Site(S)',
      dataIndex: 'dummy',
      key: 'site',
      render: (text, record: FacebookCampaignsInsights, index) => (
        <TitleWithDesc title={record.siteWithUTMCount.officialName} desc={`Id: ${record.siteWithUTMCount._id}`} />
      ),
    }, */
    {
      title: 'Impressions',
      dataIndex: 'impressions',
      key: 'impressions',
      render: (text) => toUS(text),
    },
    {
      title: 'Reach',
      dataIndex: 'reach',
      key: 'reach',
      render: (text) => toUS(text),
    },

    {
      title: 'Clicks',
      dataIndex: 'clicks',
      key: 'clicks',
      render: (text, record: FacebookCampaignsInsights, index) => (
        <TitleWithDesc
          title={toUS(text)}
          desc={`Pr. click: ${toUS(Number(record.spend) / Number(record.clicks), 2)} kr.`}
        />
      ),
    },
    {
      title: 'Spend',
      dataIndex: 'spend',
      key: 'spend',
      render: (text, record: FacebookCampaignsInsights, index) => (
        <p>
          {toUS(text)}{' '}
          <span className="text-muted" style={{ fontSize: '0.6rem' }}>
            kr.
          </span>
        </p>
      ),
    },
  ]

  return (
    <div>
      <Table dataSource={facebookCampaignsInsights} pagination={{ hideOnSinglePage: true }} columns={columns} />
      <p className="text-muted mt-2" style={{ fontSize: '0.7rem' }}>
        Sites are mapped to campaigns in Admin module.
      </p>
    </div>
  )
}
